import React from 'react';
import { AppIntlProvider } from '../../i18n/AppIntlProvider';
import { ThemeProvider } from '../../hooks/useThemeContext';
import { MicrophonePermissionPage } from './MicrophonePermissionPage';

export const MICROPHONE_PERMISSION_PATH = '/extension/microphone-permission';

/**
 * Root for `MICROPHONE_PERMISSION_PATH`, loaded by the extension's `microphone_permission.html`.
 * It only asks the browser for the microphone, so it skips the app shell: no auth, Statsig, UFO or
 * chat preload.
 */
export default function MicrophonePermissionRoot(): React.JSX.Element {
	return (
		<AppIntlProvider>
			<ThemeProvider>
				<MicrophonePermissionPage />
			</ThemeProvider>
		</AppIntlProvider>
	);
}
